import { AlienAnimation } from '@/features/timeGame/types';

import alienArieCorrect from '@/features/timeGame/assets/lottie/aliens/alien-arie-correct.json';
import alienArieIdle from '@/features/timeGame/assets/lottie/aliens/alien-arie-idle.json';
import alienArieIrritated from '@/features/timeGame/assets/lottie/aliens/alien-arie-irritated.json';
import alienArieWrong from '@/features/timeGame/assets/lottie/aliens/alien-arie-wrong.json';
import alienDirkDuikerCorrect from '@/features/timeGame/assets/lottie/aliens/alien-dirk-duiker-correct.json';
import alienDirkDuikerIdle from '@/features/timeGame/assets/lottie/aliens/alien-dirk-duiker-idle.json';
import alienDirkDuikerIrritated from '@/features/timeGame/assets/lottie/aliens/alien-dirk-duiker-irritated.json';
import alienDirkDuikerWrong from '@/features/timeGame/assets/lottie/aliens/alien-dirk-duiker-wrong.json';
import alienFrisseFritsCorrect from '@/features/timeGame/assets/lottie/aliens/alien-frisse-frits-correct.json';
import alienFrisseFritsIdle from '@/features/timeGame/assets/lottie/aliens/alien-frisse-frits-idle.json';
import alienFrisseFritsIrritated from '@/features/timeGame/assets/lottie/aliens/alien-frisse-frits-irritated.json';
import alienFrisseFritsWrong from '@/features/timeGame/assets/lottie/aliens/alien-frisse-frits-wrong.json';
import alienGeleGilbertCorrect from '@/features/timeGame/assets/lottie/aliens/alien-gele-gilbert-correct.json';
import alienGeleGilbertIdle from '@/features/timeGame/assets/lottie/aliens/alien-gele-gilbert-idle.json';
import alienGeleGilbertIrritated from '@/features/timeGame/assets/lottie/aliens/alien-gele-gilbert-irritated.json';
import alienGeleGilbertWrong from '@/features/timeGame/assets/lottie/aliens/alien-gele-gilbert-wrong.json';
import alienHarigeHarryCorrect from '@/features/timeGame/assets/lottie/aliens/alien-harige-harry-correct.json';
import alienHarigeHarryIdle from '@/features/timeGame/assets/lottie/aliens/alien-harige-harry-idle.json';
import alienHarigeHarryIrritated from '@/features/timeGame/assets/lottie/aliens/alien-harige-harry-irritated.json';
import alienHarigeHarryWrong from '@/features/timeGame/assets/lottie/aliens/alien-harrige-harry-wrong.json';
import alienOranjeOlafCorrect from '@/features/timeGame/assets/lottie/aliens/alien-oranje-olaf-correct.json';
import alienOranjeOlafIdle from '@/features/timeGame/assets/lottie/aliens/alien-oranje-olaf-idle.json';
import alienOranjeOlafIrritated from '@/features/timeGame/assets/lottie/aliens/alien-oranje-olaf-irritated.json';
import alienOranjeOlafWrong from '@/features/timeGame/assets/lottie/aliens/alien-oranje-olaf-wrong.json';
import alienPeterPatvinderCorrect from '@/features/timeGame/assets/lottie/aliens/alien-peter-patvinder-correct.json';
import alienPeterPatvinderIdle from '@/features/timeGame/assets/lottie/aliens/alien-peter-patvinder-idle.json';
import alienPeterPatvinderIrritated from '@/features/timeGame/assets/lottie/aliens/alien-peter-patvinder-irritated.json';
import alienPeterPatvinderWrong from '@/features/timeGame/assets/lottie/aliens/alien-peter-patvinder-wrong.json';
import alienTeddyToddlerCorrect from '@/features/timeGame/assets/lottie/aliens/alien-teddy-toddler-correct.json';
import alienTeddyToddlerIdle from '@/features/timeGame/assets/lottie/aliens/alien-teddy-toddler-idle.json';
import alienTeddyToddlerIrritated from '@/features/timeGame/assets/lottie/aliens/alien-teddy-toddler-irritated.json';
import alienTeddyToddlerWrong from '@/features/timeGame/assets/lottie/aliens/alien-teddy-toddler-wrong.json';
import alienWinterWinstonCorrect from '@/features/timeGame/assets/lottie/aliens/alien-winter-winston-correct.json';
import alienWinterWinstonIdle from '@/features/timeGame/assets/lottie/aliens/alien-winter-winston-idle.json';
import alienWinterWinstonIrritated from '@/features/timeGame/assets/lottie/aliens/alien-winter-winston-irritated.json';
import alienWinterWinstonWrong from '@/features/timeGame/assets/lottie/aliens/alien-winter-winston-wrong.json';

export const alienAnimations: AlienAnimation[] = [
	{
		id: 'alien-arie',
		idleAnimation: alienArieIdle,
		irritatedAnimation: alienArieIrritated,
		correctAnimation: alienArieCorrect,
		wrongAnimation: alienArieWrong,
	},
	{
		id: 'alien-dirk-duiker',
		idleAnimation: alienDirkDuikerIdle,
		irritatedAnimation: alienDirkDuikerIrritated,
		correctAnimation: alienDirkDuikerCorrect,
		wrongAnimation: alienDirkDuikerWrong,
	},
	{
		id: 'alien-frisse-frits',
		idleAnimation: alienFrisseFritsIdle,
		irritatedAnimation: alienFrisseFritsIrritated,
		correctAnimation: alienFrisseFritsCorrect,
		wrongAnimation: alienFrisseFritsWrong,
	},
	{
		id: 'alien-gele-gilbert',
		idleAnimation: alienGeleGilbertIdle,
		irritatedAnimation: alienGeleGilbertIrritated,
		correctAnimation: alienGeleGilbertCorrect,
		wrongAnimation: alienGeleGilbertWrong,
	},
	{
		id: 'alien-harige-harry',
		idleAnimation: alienHarigeHarryIdle,
		irritatedAnimation: alienHarigeHarryIrritated,
		correctAnimation: alienHarigeHarryCorrect,
		wrongAnimation: alienHarigeHarryWrong,
	},
	{
		id: 'alien-oranje-olaf',
		idleAnimation: alienOranjeOlafIdle,
		irritatedAnimation: alienOranjeOlafIrritated,
		correctAnimation: alienOranjeOlafCorrect,
		wrongAnimation: alienOranjeOlafWrong,
	},
	{
		id: 'alien-peter-patvinder',
		idleAnimation: alienPeterPatvinderIdle,
		irritatedAnimation: alienPeterPatvinderIrritated,
		correctAnimation: alienPeterPatvinderCorrect,
		wrongAnimation: alienPeterPatvinderWrong,
	},
	{
		id: 'alien-teddy-toddler',
		idleAnimation: alienTeddyToddlerIdle,
		irritatedAnimation: alienTeddyToddlerIrritated,
		correctAnimation: alienTeddyToddlerCorrect,
		wrongAnimation: alienTeddyToddlerWrong,
	},
	{
		id: 'alien-winter-winston',
		idleAnimation: alienWinterWinstonIdle,
		irritatedAnimation: alienWinterWinstonIrritated,
		correctAnimation: alienWinterWinstonCorrect,
		wrongAnimation: alienWinterWinstonWrong,
	},
];
